<template>
  <v-card class="mb-12 mt-5" min-height="200px" elevation="0">
    <p>Coloque aqui cualquier observacion con respecto al medicamento por ejemplo:(El medicamento
      solo lo tomo cuando me duele la cabeza)</p>
    <v-textarea outlined v-model="observaciones"></v-textarea>
    <v-divider class="my-4"></v-divider>
    <p class="text-center text-h6">AUTORIZACIÓN DE USO DE INFORMACIÓN</p>
    <p class="my-4 text-justify">
      Autorizo el tratamiento de mis datos personales y datos personales sensibles por Sociedad Minera Cerro
      Verde S.A.A. e International SOS y conozco que puedo ejercer mis derechos de acceso, rectificación,
      cancelación y oposición en cualquier momento, enviando un correo electrónico a
      SM-CVE-datospersonales&#64;fmi.com y DL.SUP.ASIS&#64;internationalsos.com. Para cualquier información
      adicional, consultar la política de privacidad cargada en nuestro sitio web https://www.cerroverde.pe y en
      el siguiente
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <a :href="pdfUrl" target="_blank" v-bind="props" @click.stop>enlace</a>
        </template>
        Click para ver la política de privacidad
      </v-tooltip> .
    </p>
    <v-radio-group v-model="autorizaDatos" inline hide-details>
      <v-radio label="SI" color="indigo-darken-4" :value="true"></v-radio>
      <v-radio label="NO" color="indigo-darken-4" :value="false"></v-radio>
    </v-radio-group>
    <p v-if="autorizaDatos !== true" class="text-caption text-orange">
      Debe marcar SI para poder guardar la declaración.
    </p>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  watch: {
  },
  computed: {
    observaciones: {
      get() { return this.$store.state.observaciones },
      set(val) { this.$store.commit('SET_OBSERVACIONES', val) }
    },
    autorizaDatos: {
      get() { return this.$store.state.autorizaDatos },
      set(val) { this.$store.commit('SET_AUTORIZA_DATOS', val) }
    },
    pdfUrl() {
      return process.env.BASE_URL + 'politica_datos_ES.pdf'
    },
  },
  methods: {
  },
  created() {
    this.$store.dispatch('fetchComentarios', this.$route.params.id)
  }
}
</script>